<template>
  <div class="basic-block block-about-fortune-base" :style="styles">
    <img v-if="targetInfo.fortune.deco" :src="targetInfo.fortune.deco" class="block-about-fortune-base__deco" alt="">
    <div class="content-wrap">
      <div class="block-about-fortune-base__inner">
        <lp-title title="占術紹介" :color-scheme="colorScheme" alphabet="fortune-telling" />
        <h3 class="block-about-fortune-base__headline">{{ targetInfo.fortune.headline }}</h3>
        <p class="block-about-fortune-base__text" v-html="targetInfo.fortune.text"></p>
        <!-- 誕生日からわかる・・・ -->
        <div class="block-about-fortune-base__box first">
          <img :src="targetInfo.fortune.kira" class="block-about-fortune-base__kira" alt="" width="44">
          <h3 class="block-about-fortune-base__you-headline" v-html="targetInfo.fortune.you.headline"></h3>
          <p class="block-about-fortune-base__you-text">{{ targetInfo.fortune.you.text }}</p>
          <div class="block-about-fortune-base__you-counselor">
            <p class="block-about-fortune-base__you-comment" v-html="targetInfo.fortune.you.comment"></p>
            <img class="block-about-fortune-base__you-counselor-image" :src="targetInfo.fortune.you.counselorImage" alt="">
          </div>
          <div class="block-about-fortune-base__you-sample">
            <img :src="targetInfo.fortune.you.avatar" alt="" class="block-about-fortune-base__you-avator">
            <ul class="block-about-fortune-base__you-sample-list">
              <li v-for="(v, i) in targetInfo.fortune.you.sample" :key="i">
                <img :src="v.icon" alt="">
                <p>{{ v.text }}</p>
              </li>
            </ul>
          </div>
          <p class="block-about-fortune-base__you-advice" v-html="targetInfo.fortune.you.advice"></p>
        </div>
        <!-- lineキャンペーンバナー追加 -->
        <!-- <line-campaign-message class="line-campaign-message--top" :target-info="targetInfo" :color-scheme="colorScheme"/> -->
        <block-banner
          class="block-banner--top"
          banner-pos="top"
          :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
          :lp-id="this.lpId"
          :campaign="bannerType"
          :target-info="targetInfo"
          :color-scheme="colorScheme"
          :has-caption="true"
        />
        <!-- 占術のこと -->
        <div class="block-about-fortune-base__box second">
          <img :src="targetInfo.fortune.kira" class="block-about-fortune-base__kira" alt="" width="44">
          <h3 class="block-about-fortune-base__method-headline" v-html="targetInfo.fortune.method.headline"></h3>
          <p class="block-about-fortune-base__method-text" v-html="targetInfo.fortune.method.text"></p>
          <div class="block-about-fortune-base__method-sample">
            <img :src="targetInfo.fortune.method.avatar" alt="" class="block-about-fortune-base__method-avator">
            <ul class="block-about-fortune-base__method-sample-list">
              <li v-for="(v, i) in targetInfo.fortune.method.sample" :key="i">
                <img :src="v.icon" alt="">
                <p>{{ v.text }}</p>
              </li>
            </ul>
          </div>
          <div class="block-about-fortune-base__method-counselor">
            <img class="block-about-fortune-base__method-counselor-image" :src="targetInfo.fortune.method.counselorImage" alt="">
            <p class="block-about-fortune-base__method-advice" v-html="targetInfo.fortune.method.advice"></p>
          </div>
        </div>
      </div>
      <!-- 無料診断 -->
      <div class="block-about-fortune-base__free">
        <svg viewBox="0 0 375 66" fill="#fcf9e1" class="block-about-fortune-base__free-curve" xmlns="http://www.w3.org/2000/svg">
          <path d="M375 0H0V42C0 42 78.5 65.9488 187.5 65.9488C296.5 65.9488 375 42 375 42V0Z"/>
        </svg>
        <div class="block-about-fortune-base__free-row">
          <!-- <img :src="targetInfo.fortune.kira" class="block-about-fortune-base__kira" alt="" width="44"> -->
          <p class="block-about-fortune-base__free-text">{{ targetInfo.fortune.free.text }}</p>
          <img :src="targetInfo.fortune.free.img" alt="" class="block-about-fortune-base__free-img">
        </div>
        <lp-base-button
          label="試しに無料診断"
          design="primary"
          :color-scheme="colorScheme"
          @clicked="clicked"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LpTitle from '@/utvStore/components/recommend/lp/partials/LpTitle'
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'

export default {
  name: 'BlockAboutFortune',
  components: {
    LpTitle,
    LpBaseButton,
    BlockBanner,
    LineCampaignMessage
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    lpId: Number,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked () {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-free-shindan-button`,
      })
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-about-fortune-base {
  background: rgba(255, 249, 218, 0.75);
  padding: 48px 0 0;
  &__deco {
    position: absolute;
    top: -47px;
    right: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 2;
  }
  &__inner {
    padding: 0 20px;
  }
  &__headline {
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    text-align: justify;
    color: $l_col_keycolor;
    margin: 0 0 8px;
  }
  &__text {
    font-size: 14px;
    line-height: 21px;
    text-align: justify;
    margin: 0 0 20px;
  }
  &__box {
    background: #FFFFFF;
    border-radius: 10px;
    padding: 24px 5.97%;
    margin: 0 auto 24px;
    position: relative;
    &:last-of-type {
      margin-bottom: 16px;
    }
  }
  &__kira {
    position: absolute;
    top: -20px;
    left: 15px;
  }
  &__you-headline,
  &__method-headline {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 0 16px;
  }
  &__you-text,
  &__method-text {
    font-size: 14px;
    line-height: 21px;
    text-align: justify;
    margin: 0 0 16px;
  }
  &__you-counselor {
    display: flex;
    align-items: center;
    margin: 0 0 16px;
  }
  &__you-counselor-image {
    flex: 0 1 80px;
    max-width: 80px;
  }
  &__you-comment {
    font-size: 14px;
    line-height: 20px;
    text-align: justify;
    background: $l_col_second;
    border-radius: 8px;
    padding: 12px 12px 15px;
    margin: 0 13px 0 0;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: calc(100% - 1px);
      margin: auto;
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-left-color: $l_col_second;
    }
  }
  &__you-sample {
    background: rgba(#FFFFFF, 0.75);
    border: 1px solid #DADADA;
    border-radius: 10px;
    padding: 24px 16px;
    margin: 0 0 24px;
  }
  &__you-avator {
    display: block;
    margin: 0 auto 16px;
    width: 80px;
  }
  &__you-sample-list {
    list-style: none;
    max-width: 380px;
    margin: 0 auto;
    padding: 0;
    li {
      display: flex;
      align-items: center;
      + li {
        margin-top: 10px;
      }
    }
    img {
      flex: 0 1 auto;
      max-width: 68px;
      margin: 0 5px 0 0;
    }
    p {
      flex: 1 1 auto;
      margin: 0;
      font-size: 13px;
      line-height: 21px;
      text-align: justify;
    }
  }
  &__you-advice {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0;
  }
  &__method-sample {
    display: flex;
    align-items: center;
    max-width: 380px;
    margin: auto;
  }
  &__method-avator {
    margin: 0 8px 0 0;
    flex: 0 1 auto;
    max-width: 80px;
  }
  &__method-sample-list {
    list-style: none;
    margin: 0 auto;
    padding: 0;
    li {
      border: 1px solid #DADADA;
      border-radius: 10px;
      display: flex;
      align-items: center;
      padding: 10px 16px;
      + li {
        margin-top: 10px;
      }
    }
    img {
      flex: 0 1 auto;
      max-width: 68px;
      margin: 0 5px 0 0;
    }
    p {
      flex: 1 1 auto;
      margin: 0;
      font-size: 13px;
      line-height: 18px;
      text-align: justify;
    }
  }
  &__method-counselor {
    display: flex;
    align-items: center;
    max-width: 380px;
    margin: auto;
  }
  &__method-counselor-image {
    flex: 0 1 auto;
    max-width: 80px;
    margin: 0 8px 0 0;
  }
  &__method-advice {
    flex: 1 1 auto;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    color: $l_col_keycolor;
  }
  &__free {
    background: $l_col_second;
    padding: 0 0 36px;
    position: relative;
    overflow: hidden;
  }
  &__free-curve {
    position: absolute;
    @include mq('w580') {
      top: -35px;
    }
  }
  &__free-row {
    display: flex;
    align-items: flex-end;
    max-width: 415px;
    margin: 0 auto 16px;
    padding: 0 13px 0 20px;
    position: relative;
  }
  &__free-row &__kira {
    top: 24px;
    left: 10px;
  }
  &__free-text {
    flex: 1 1 auto;
    margin: 0 11px 21px 0;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    color: #FFFFFF;
  }
  &__free-img {
    max-width: 169px;
  }
  .baseButton {
    width: 80%;
    max-width: 382px;
    margin: auto;
  }
  .block-banner--top {
    background: #FBF8F1;
    padding: 8px 0 44px;
  }
  .line-campaign-message--top {
    background: none;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/houen/blocks/BlockAboutFortune.vue